module.exports = __webpack_public_path__ + "static/vlad-3375ed0c3242099fe0f6f3761cb440a9.png";